(ns journal-app-client.modals.confirm
  (:require [journal-app-client.components.button :as button]
            [journal-app-client.components.modal :as m]
            [re-frame.core :as rf]))

(defn main [id props]
  [:<>
   (when (:title props)
     [m/header
      {:class (:header-class props)}
      [:h1.modal-card-title (:title props)]
      [button/button
       {:aria-label "Close"
        :class      "is-rounded"
        :style      {:background-color "transparent"
                     :padding          "1rem"
                     :border-color     "var(--scheme-main)"}
        :on-click   #(rf/dispatch [:close-modal id])}
       [:span.icon [:i.fas.fa-close]]]])
   [m/body (:modal-card-props props)
    (if (string? (:children props))
      [:p.subtitle (:children props)]
      (:children props))]
   (when-not (false? (:has-footer? props))
     [m/footer {:style (merge {:flex-wrap "wrap"
                               :padding   "1rem"}
                              (:style (:footer-props props)))}
      [button/button
       {:aria-label "Close"
        :class      (:class (:cancel-props props))
        :style      (merge {:flex   1
                            :margin "0.25rem"}
                           (:style (:cancel-props props)))
        :on-click   (fn [event]
                      (rf/dispatch [:close-modal id])
                      (when (fn? (:on-click (:cancel-props props)))
                        ((:on-click (:cancel-props props)) event)))}
       [:span (or (:cancel-text props) "Cancel")]]
      [button/button
       (merge (dissoc (:confirm-props props) :loading-key)
              {:class    (or (:class (:confirm-props props)) "is-success")
               :style    (merge {:flex   1
                                 :margin "0.25rem"}
                                (:style (:confirm-props props)))
               :loading? (when (:loading-key (:confirm-props props))
                           (get @(rf/subscribe [:loading]) (:loading-key (:confirm-props props))))
               :on-click (fn [event]
                           (when (fn? (:on-click (:confirm-props props)))
                             ((:on-click (:confirm-props props)) event)))})
       [:span (or (:confirm-text props) "Confirm")]]])])